import Resource from './resource.js';

export default class Meetings extends Resource {
	async getMeeting(name) {
		return Promise.all([this.httpGet('meetings?name=' + name, false),
						   this.httpGet('linktypes', false)]);
	}
}
